import { Injectable } from '@angular/core';
import CustomStore from 'devextreme/data/custom_store';
import { EntityQuery, iBisEntityService } from '@dohu/ibis-entity';
import { iBisAuthService, iBisSecureEditService } from '@dohu/ibis-auth';
import { iBisLanguageService, iBisServerConfig } from '@dohu/ibis-common';
import { SpecializationFormSetting } from './form-settings/edit-specialization-form-setings.service';

@Injectable({
	providedIn: 'root'
})
export class EditSpecializationService extends iBisSecureEditService {
	public data: CustomStore;
	public calendarData: CustomStore;
	public userData: CustomStore;

	private usId: string;

	constructor(auth: iBisAuthService, entity: iBisEntityService, config: iBisServerConfig, lg: iBisLanguageService) {
		super(auth, entity, config, lg);
		this.title = 'SPECIALIZATION';
		this.validation = 'SpecializationValidation';
	}
	protected load(): void {
		this.data = this.getData();
		this.calendarData = this.getCalendarData();
	}
	public set userId(id: string) {
		this.usId = id;
		this.userData = this.getUserData();
	}
	createDefault() {
		return { isActiv: true };
	}
	getById(id: string): Promise<any> {
		return new Promise((resolve, reject) => {
			this.entity.getById('Specialization', id).then((obj) => {
				if (obj) {
					resolve(obj);
				} else {
					reject();
				}
			}, error => this.lg.showError(error));
		});
	}
	onRemove(id: string): Promise<void> {
		return this.entity.remove('Specialization', id);
	}
	onSaveEv(serverUrl?: string): Promise<any> {
		if(this.model.id){
			return this.entity.save('Specialization', this.model.id, this.model);
		} else{
			return new Promise((resolve, reject) => {
				this.entity.insert('Specialization', this.model).then((result) => {
					const obj = new SpecializationFormSetting(result.id);
					this.entity.insert('SpecializationFormSetting', obj).then(() => {
						resolve('OK');
					});
				});
			});
		}
	}
	reset(): void {
		this.model = this.createDefault();
	}
	private getData(): CustomStore {
		return this.entity.store(new EntityQuery('Specialization').addOrderBy(['code']));
	}

	private getCalendarData(): CustomStore {
		// TODO: make linkEq, and eq with partyId => ds.authDetails.party.id;
		const q = new EntityQuery('Specialization', false, true).addOrderBy(['code']);
		q.link('id', 'specializationId', new EntityQuery('UserSpecialization'));
		return this.entity.store(q);
	}

	private getUserData(): CustomStore {
		const q = new EntityQuery('UserSpecialization')
		if(this.usId){
			q.eq('userId', this.usId);
		}
		const qq = new EntityQuery('Specialization', false, true).link('id', 'specializationId', q).addOrderBy(['description']);
		return this.entity.store(qq);
	}
}
